module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "text-xs-center": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": " Errores comunes en la administración del dinero"
    }
  }), _vm._v(" "), _c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Errores comunes en la administración del dinero',
      "videoEmbed": "ADMINISTRACIONDINERO56Errores.mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), (_vm.videoAcc) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-5": ""
    }
  }, [_c('video-app', {
    staticClass: "adorn-bottom",
    attrs: {
      "videoSize": 700,
      "vidTittle": "video Presentacion",
      "youtubeEmbed": "9KuYnJNfQHU?autoplay=1&rel=0"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8d60bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-56.vue
// module id = 1028
// module chunks = 1